/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import * as actionTypes from './actionTypes';

const initialState = {
  performDisputeResolutionObj: {},

  planType: [],
  selectedPlanType: '',
  rebateProgram: [],
  errorMsgProgram: [],
  rebateProgramName: {},
  startQtr: '',
  programAndEligibility: [],
  displayObj: {
    rebateProgramName: {},
    startQtr: '',
    programAndEligibility: [],
  },
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENT_DISPUTE_DISPLAY_OBJ_PRO:
      return { ...state, performDisputeResolutionObj: action.screenData };

    case actionTypes.GET_CURRENT_DISPUTE_DISPLAY_DETAIL_OBJ_PRO:
      return { ...state, disputeResolutionDetailObj: action.detailScrData };

    case actionTypes.GET_ERROR_MSG_PRO:
      return { ...state, errorMsgProgram: action.payload };
    case actionTypes.GET_PLAN_TYPE_DATA_PRO:
      return { ...state, planType: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_PRO:
      return { ...state, rebateProgram: action.payload };

    case actionTypes.GET_REBATE_QUARTER_VALUE:
      return { ...state, startQtr: action.payload };
    case actionTypes.GET_PROGRAM_AND_ELIGIBILITY:
      let displayObj = {
        ...state.displayObj,
        programAndEligibility: action.payload,
      };
      return { ...state, programAndEligibility: action.payload, displayObj };
    case actionTypes.SET_DISPLAY_OBJ_PRO:
      // let tempObj = {
      //   ...state.displayObj,
      //   rebateProgramName: {
      //     ...action.payload.rebateProgramName,
      //   },
      // };

      let tempObj = JSON.parse(JSON.stringify(action.payload));
      return { ...state, displayObj: tempObj };
    case actionTypes.GET_REBATE_PROGRAM_NAME_PRO:
      return { ...state, rebateProgramName: action.payload };
    case actionTypes.SEARCH_PRO:
      return { ...state, ...action.payload };
    case actionTypes.SET_REFRESH_DATA_PRO:
      return {
        ...state,
        performDisputeResolutionObj: {},

        planType: [],
        selectedPlanType: '',
        rebateProgram: [],
        errorMsgProgram: [],
        rebateProgramName: {},
      };
    case actionTypes.SET_REFRESH_DATA_PRO_DISPLAY:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };
    default:
      return state;
  }
};
export default reducer;
